export default __webpack_public_path__ + "static/media/background.1af38f56.jpg";